import React from 'react';
import { SidebarNavigation } from '../navigation/sidebar';
import { TopNavigation } from '../navigation/top-nav';
import { cn } from '../../utils';

interface SidebarLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function SidebarLayout({ children, className }: SidebarLayoutProps) {
  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-secondary-900">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white dark:focus:bg-secondary-800 focus:text-primary-700 dark:focus:text-primary-400 focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        Skip to main content
      </a>
      <div className="print:hidden contents">
        <SidebarNavigation />
      </div>
      <div className="flex-1 flex flex-col">
        <div className="print:hidden">
          <TopNavigation />
        </div>
        <main id="main-content" tabIndex={-1} className={cn('flex-1 p-8 focus:outline-none', className)}>
          {children}
        </main>
      </div>
    </div>
  );
}

export function PageHeader({ 
  title, 
  subtitle, 
  actions, 
  className 
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('mb-8', className)}>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">{title}</h1>
          {subtitle && (
            <p className="mt-2 text-gray-600 dark:text-secondary-400">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center space-x-3">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export function Card({ 
  children, 
  className,
  padding = true 
}: {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}) {
  return (
    <div className={cn(
      'bg-white dark:bg-secondary-800 rounded-lg border border-gray-200 dark:border-secondary-700 shadow-sm',
      padding && 'p-6',
      className
    )}>
      {children}
    </div>
  );
}